module.exports = __webpack_public_path__ + "img/featured-vehicles-v2-ford.bb07664a.png";